<div class="container">
    <div class="inner-container" [ngStyle]="{
        'max-width': view === 'potrait' ? (mobileView? '120px': '192px') : (mobileView? '160px': '256px')
        }">
        <div *ngIf="image" [class]="view === 'potrait' ? 'image-container-potrait border-radius-2' : 'image-container-landscape border-radius-2'">
            <uni-image
                [src]="image"
                alt="thumbnail-image"
                [height]="view === 'potrait' ? (mobileView? 160: 256) : (mobileView? 120: 192)"
                [width]="view === 'potrait' ? (mobileView? 120: 192) : (mobileView? 160: 256)"
                classes="border-radius-2"
                [auxClassList]="view === 'potrait' ? 'thumbnail-image-potrait' : 'thumbnail-image-landscape'">
            </uni-image>
            <div class="icon-box">
                <div class="icon">
                    <i (click)="fileInput.click()" class="icon-upload">
                        <input hidden type="file" #fileInput (change)="onFileChanged($event)" accept="image/*">
                    </i>
                </div>
                <div class="icon icon-delete-box">
                    <i (click)="deleteThumbnail()" class="icon-delete-bold"></i>
                </div>
            </div>
        </div>
        <i *ngIf="!image" (click)="fileInput.click()" [class]="'thumbnail icon-upload '+ view">
            <input hidden type="file" #fileInput (change)="onFileChanged($event)" accept="image/*">
        </i>
        <p class="thumbnail-text font-bold">Add Thumbnail*</p>
        <span class="sparro-grey-500" style="font-size: 12px; line-height: 14.06px;">Recommended size {{
            view === 'potrait' ? '1125 x1500px in ratio 3:4 potrait' : '1500 x1125px in ratio 4:3 landscape'
        }}.</span>
    </div>
    <div class="inner-container" [ngStyle]="{'gap': mobileView? '16px': '24px'}">
        <span class="title-content">
            {{ title }} </span>
        <span [ngStyle]="{'font-size': mobileView? '12px': '16px', 'line-height': mobileView? '14px': '24px'}">
            {{ subtitle | truncate: 100 }} </span>
    </div>
</div>